import { render, staticRenderFns } from "./BrowseAssessmentsResults.vue?vue&type=template&id=992a5518&scoped=true"
import script from "./BrowseAssessmentsResults.vue?vue&type=script&lang=js"
export * from "./BrowseAssessmentsResults.vue?vue&type=script&lang=js"
import style0 from "./BrowseAssessmentsResults.vue?vue&type=style&index=0&id=992a5518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992a5518",
  null
  
)

export default component.exports